import { render, staticRenderFns } from "./ScoreCategoryList.vue?vue&type=template&id=5bf7ce87&"
import script from "./ScoreCategoryList.vue?vue&type=script&lang=js&"
export * from "./ScoreCategoryList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports